module.exports = new __parcel__URL__("default_left.dfc31853.svg").toString();